import { makeStyles } from '@material-ui/styles';
// import tinycolor from 'tinycolor2';

export default makeStyles(theme => ({
    st0: {
        fill: '#1CB1F9',
        stroke: '#1CB1F9',
    },

    st1: {
        fill: '#FFFFFF',
    },

    st2: {
        clipPath: 'url(#SVGID_2_)',
    },

    st3: {
        fill: '#F28C00',
    },

    st4: {
        fill: '#EE7624',
    },

    st5: {
        fill: '#009BE0',
    },

    st6: {
        fill: '#01BFD7',
    },

    st7: {
        fill: '#F9BF01',
    },

    st8: {
        fill: '#76BD22',
    },

    st9: {
        fill: '#00A8E2',
    },

    st10: {
        fill: 'none',
    },

    st11: {
        fontFamily: 'Roboto, sans-serif',
        // fontFamily: 'Open Sans, sans-serif',
    },

    st12: {
        fontSize: '15px',
        // fontWeight: '600',
    },

}));
